<template>
    <div class="page-guests">
        <el-dialog
                :width="(!$mobile() ? '350px' : '700px')"
                :title="(editMode ? 'Редактировать заявку' : 'Добавить заявку')"
                :visible.sync="addVisible"
        >
            <el-row :gutter="50">
                <el-col v-if="$mobile()" :span="8" align="justify">
                    Будет создано приглашение для въезда на гостевую парковку организации.
                    <br><br>
                    К письму прилагается QR-код, который можно распечатать или сохранить в мобильном устройстве, после чего на въезде приложить его к считывателю QR-кодов или связаться с оператором по громкой связи для получения парковочного билета.
                </el-col>
                <el-col :span="(!$mobile() ? 24 : 16)">
                    <el-form ref="form" :model="model">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="Организация" prop="ArendatorID" :rules="[{ required: true, message: 'Имя гостя не заполнено' }]">
                                    <el-select filterable v-model="model.ArendatorID" placeholder="Выберите организацию" class="w-100">
                                        <el-option
                                                v-for="item in companies"
                                                :key="item.ID"
                                                :label="item.Name"
                                                :multiple="false"
                                                :value="item.ID">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Имя гостя" prop="GuestName" :rules="[{ required: true, message: 'Имя гостя не заполнено' }]">
                                    <el-input v-model="model.GuestName" placeholder="Введите имя гостя"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Телефон" prop="GuestPhone">
                                    <el-input v-model="model.GuestPhone" placeholder="Введите телефон"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="E-mail" prop="GuestMail" :rules="[{ required: model.sendInvite, message: 'Необходимо ввести e-mail' }]">
                                    <el-input v-model="model.GuestMail" placeholder="Введите E-mail"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Гос. номер автомобиля" prop="CarPlate">
                                    <el-input v-model="model.CarPlate" placeholder="Введите гос. номер"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Место на парковке" prop="GuestPlace">
                                    <el-input v-model="model.GuestPlace" placeholder="Место №"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Действует с" prop="EntryTimeBegin" :rules="[{ required: true, message: 'Укажите время начала заявки' }]">
                                    <el-date-picker
                                            class="w-100"
                                            v-model="model.EntryTimeBegin"
                                            type="datetime"
                                            placeholder="Время начала заявки"
                                            :picker-options="{ firstDayOfWeek: 1 }"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Действует до" prop="EntryTimeEnd" :rules="[{ required: true, message: 'Укажите время окончания заявки' }]">
                                    <el-date-picker
                                            class="w-100"
                                            v-model="model.EntryTimeEnd"
                                            type="datetime"
                                            placeholder="Время окончания заявки"
                                            :picker-options="{ firstDayOfWeek: 1 }"
                                    />
                                </el-form-item>
                                <el-button type="default" class="w-100" @click="tomorrow">Завтра</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="p-b-10 m-t-30">
                        <el-row :gutter="20">
                            <el-col :span="12" align="left" class="d-flex align-items-left" style="overflow: hidden;">
                                <el-checkbox class="m-l-0" v-model="model.sendInvite">{{ (!$mobile() ? 'Приглашение' : 'Выслать приглашение') }}</el-checkbox>
                            </el-col>
                            <el-col :span="12" align="right" class="d-flex align-items-right">
                                <el-button type="primary" class="w-100" @click="save" :loading="loading">{{ (editMode ? 'Сохранить' : 'Добавить') }}</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog
                :width="(!$mobile() ? '350px' : '700px')"
                title="Отправить приглашение"
                :visible.sync="sendVisible"
        >
            <div>
                <el-form :model="sendModel" v-loading="loadingMail">
                    <el-row :gutter="20">
                        <el-col align="center" :span="24">
                            <qrcode v-model="sendModel.QrCodeContent" :options="{ width: ($mobile ? 200 : 300) }"></qrcode>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item prop="text" v-if="sendModel.DefaultMailBody">
                                <el-input type="textarea" rows="6" v-model="sendModel.DefaultMailBody" placeholder="Введите имя гостя"></el-input>
                                <!--<editor-->
                                        <!--initialEditType="wysiwyg"-->
                                        <!--ref="toastuiEditor"-->
                                        <!--:initialValue="sendModel.DefaultMailBody"-->
                                        <!--previewStyle="tab"-->
                                <!--/>-->
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="p-b-10 m-t-30">
                    <el-row :gutter="20">
                        <el-col :span="12" align="left" class="d-flex align-items-left">
                            <el-button class="m-l-20" type="link" @click="sendVisible = false">Закрыть</el-button>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" @click="send" :loading="loading">Отправить</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>

        <el-dialog
                title="Выдать карту"
                :visible.sync="fetchCardVisible"
                :width="(!$mobile() ? '350px' : '436px')"
        >
            <div>
                <el-form :model="fetchCardModel">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Выберите стойку" prop="deviceId">
                                <el-select v-model="fetchCardModel.deviceId" placeholder="Выберите стойку" class="w-100">
                                    <el-option
                                            v-for="item in devices"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="p-b-10 m-t-30">
                    <el-row :gutter="20">
                        <el-col :span="12" align="left" class="d-flex align-items-left">
                            <el-button class="m-l-20" type="link" @click="fetchCardVisible = false">Закрыть</el-button>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" @click="fetch" :loading="loading">Выдать карту</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>

        <el-dialog
                title="Закрыть заявку"
                :visible.sync="closeGuestVisible"
                :width="(!$mobile() ? '350px' : '436px')"
        >
            <div>
                <el-form :model="closeGuestModel">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Выберите дату выезда" prop="date">
                                <el-input v-model="closeGuestModel.date" placeholder="Дата выезда"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="p-b-10 m-t-30">
                    <el-row :gutter="20">
                        <el-col :span="12" align="left" class="d-flex align-items-left">
                            <el-button class="m-l-20" type="link" @click="closeGuestVisible = false">Закрыть</el-button>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" @click="close" :loading="loading">Закрыть заявку</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>

        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="6" :lg="12" :xl="12" class="m-b-10 m-b-md-0">
                    <el-input placeholder="Поиск по имени гостя"
                              v-model="form.SearchString"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <!--
                <el-col :sm="24" :md="8" :lg="4" :xl="4" class="m-b-sm-10 m-b-lg-0">
                    <el-date-picker
                            class="w-100"
                            format="yyyy-MM-dd HH:mm"
                            v-model="form.From"
                            type="datetime"
                            placeholder="С даты"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :sm="24" :md="8" :lg="4" :xl="4" class="m-b-sm-10 m-b-lg-0">
                    <el-date-picker
                            class="w-100"
                            format="yyyy-MM-dd HH:mm"
                            v-model="form.To"
                            type="datetime"
                            placeholder="По дату"
                    >
                    </el-date-picker>
                </el-col>
                -->

                <el-col :sm="24" :md="6" :lg="4" :xl="4" class="m-b-10 m-b-md-0">
                    <el-button class="w-100" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                </el-col>
                <el-col v-if="companyId == 0" :sm="24" :md="6" :lg="4" :xl="4" class="m-b-10 m-b-md-0">
                    <el-button class="w-100" @click="goToReport" icon="icon-csv-file">Детализация</el-button>
                </el-col>
                <el-col :sm="24" :md="6" :lg="4" :xl="4">
                    <el-button class="w-100" @click="addGuest" icon="icon-plus">Добавить заявку</el-button>
                </el-col>
                <!--
                <el-col :sm="24" :md="6" :lg="6" :xl="6">
                    <el-button class="w-100" @click="exportCSV" icon="icon-xls-file">Экспорт Excel</el-button>
                </el-col>
                -->
            </el-row>
        </el-card>

        <el-card shadow="never" class="guests m-b-20">
            <div slot="header" class="clearfix guests__header">
                <h2>Список активных заявок</h2>
                <div class="float-right">
                    <el-select clearable v-model="form.Status" placeholder="Статус заявки" @change="filterData" class="m-r-10">
                        <el-option
                            v-for="item in statuses"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="form.isActive" placeholder="Действующие/просроченные" @change="filterData">
                        <el-option
                            v-for="item in statusesActive"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <el-row :gutter="20">
                <el-col :span="24">
                    <div v-loading="loading" v-if="!$mobile()">
                        <div v-for="(item, key) in dataTable.Rows" :key="key">
                            <card
                                v-loading="loading"
                                :title="item.Cells.find(x => x.DataMember === 'GuestName').Value"
                                :date="item.Cells.find(x => x.DataMember === 'OrderTime').Value"
                            >
                                <div>
                                    <div v-if="item.Cells.find(x => x.DataMember === 'GuestPhone').Value">Телефон гостя: {{item.Cells.find(x => x.DataMember === 'GuestPhone').Value}}</div>
                                    <div v-if="item.Cells.find(x => x.DataMember === 'CarPlate').Value">Гос.номер авто: {{item.Cells.find(x => x.DataMember === 'CarPlate').Value}}</div>
                                    <div v-if="item.Cells.find(x => x.DataMember === 'EntryTimeBegin').Value">Время въезда: {{item.Cells.find(x => x.DataMember === 'EntryTimeBegin').Value | date}}</div>
                                    <div v-if="item.Cells.find(x => x.DataMember === 'EntryTimeEnd').Value">Время выезда: {{item.Cells.find(x => x.DataMember === 'EntryTimeEnd').Value | date}}</div>
                                    <div v-if="item.Cells.find(x => x.DataMember === 'GuestPlace').Value">Место на парковке: {{item.Cells.find(x => x.DataMember === 'GuestPlace').Value}}</div>
                                    <div v-if="item.Cells.find(x => x.DataMember === 'CompanyName').Value">Компания: {{item.Cells.find(x => x.DataMember === 'CompanyName').Value}}</div>
                                </div>
                                <div class="m-t-10">
                                    <el-button v-if="companyId == 0" @click="fetchCard(item.Cells.find(x => x.DataMember === 'ID').Value)" icon="icon-payment-card" class="el-button--icon" size="mini" title="Выдать карту"></el-button>
                                    <el-button @click="sendMail(item.Cells.find(x => x.DataMember === 'ID').Value)" icon="icon-mail" class="el-button--icon" size="mini" title="Отправить приглашение"></el-button>
                                    <el-button @click="editGuest(item.Cells)" icon="icon-edit-2" class="el-button--icon" size="mini" title="Редактировать"></el-button>
                                    <el-button @click="deleteItem(item.Cells.find(x => x.DataMember === 'ID').Value)" icon="icon-trash" class="el-button--icon" type="danger" size="mini" title="Удалить"></el-button>
                                    <el-button v-if="companyId == 0" @click="closeGuest(item.Cells.find(x => x.DataMember === 'ID').Value)" icon="icon-close" type="danger" class="el-button--icon" size="mini" title="Закрыть заявку"></el-button>

                                    <!--
                                    <el-dropdown @click="dropdownHandle">
                                        <span class="el-dropdown-link">
                                            <i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                v-if="companyId == 0"
                                            >
                                                Выдать карту
                                            </el-dropdown-item>
                                            <el-dropdown-item @click="sendMail(scope.row.Cells.find(x => x.DataMember === 'ID').Value)">Отправить приглашение</el-dropdown-item>
                                            <el-dropdown-item @click="editGuest(scope.row.Cells)">Редактировать</el-dropdown-item>
                                            <el-dropdown-item @click="deleteItem(scope.row.Cells.find(x => x.DataMember === 'ID').Value)" class="color-danger">Удалить</el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="companyId == 0"
                                                @click="closeGuest(scope.row.Cells.find(x => x.DataMember === 'ID').Value)"
                                                class="color-danger"
                                            >
                                                Закрыть заявку
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    -->
                                </div>
                            </card>
                        </div>
                    </div>
                    <div v-else>
                        <el-table
                            v-loading="loading"
                            :data="dataTable.Rows"
                            v-if="dataTable"
                            :row-class-name="tableRowClassName"
                            :row-style="tableRowStyle"
                            :cell-class-name="tableRowClassName"
                            :cell-style="tableRowStyle"
                            :highlight-current-row="false"
                    >
                        <!-- eslint-disable-next-line -->
                        <el-table-column v-if="($mobile() && header.ColumnVisible) || (!$mobile() && header.ColumnVisible && header.DataMember !== 'ID' && header.DataMember !== 'CarPlate' && header.DataMember !== 'CardID' && header.DataMember !== 'State')"
                                v-for="(header, index) in dataTable.Headers"
                                :key="index"
                                :prop="'Cells.' + header.DataMember"
                                :label="header.DisplayName"
                                :title="header.Description"
                        >
                            <template slot-scope="scope">
                                <div>
                                    <div v-if="header.DataType === 'DateTime'">
                                        <table-date :date="scope.row.Cells.find(x => x.DataMember === header.DataMember).Value" />
                                    </div>
                                    <div v-else-if="header.DataType === 'Decimal'">
                                        {{scope.row.Cells.find(x => x.DataMember === header.DataMember).Value | rubles }}
                                    </div>
                                    <div v-else>
                                        {{scope.row.Cells.find(x => x.DataMember === header.DataMember).Value}}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="dataTable.Rows && dataTable.Rows.length"
                            fixed="right"
                            :width="($mobile() ? '250px' : '55px')"
                            align="right"
                        >
                            <template slot-scope="scope">
                                <el-button v-if="companyId == 0" @click="fetchCard(scope.row.Cells.find(x => x.DataMember === 'ID').Value)" icon="icon-payment-card" class="el-button--icon" size="mini" title="Выдать карту"></el-button>
                                <el-button @click="sendMail(scope.row.Cells.find(x => x.DataMember === 'ID').Value)" icon="icon-mail" class="el-button--icon" size="mini" title="Отправить приглашение"></el-button>
                                <el-button @click="editGuest(scope.row.Cells)" icon="icon-edit-2" class="el-button--icon" size="mini" title="Редактировать"></el-button>
                                <el-button @click="deleteItem(scope.row.Cells.find(x => x.DataMember === 'ID').Value)" icon="icon-trash" class="el-button--icon" type="danger" size="mini" title="Удалить"></el-button>
                                <el-button v-if="companyId == 0" @click="closeGuest(scope.row.Cells.find(x => x.DataMember === 'ID').Value)" icon="icon-close" type="danger" class="el-button--icon" size="mini" title="Закрыть заявку"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <!--
        <div class="m-t-20 text-center">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="form.Page"
                    :page-sizes="[10, 20, 100, 200, 300, 400]"
                    :page-size="form.PageSize"
                    layout="sizes, prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
        -->
    </div>
</template>

<script>
    import Vue from 'vue'
    // import '@toast-ui/editor/dist/toastui-editor.css'
    // import { Editor } from '@toast-ui/vue-editor'

    export default {
        // components: { editor: Editor },
        data () {
            return {
                companyId: sessionStorage.getItem('companyId'),
                loading: false,
                loadingMail: false,
                total: 63,
                addVisible: false,
                editMode: false,
                form: {
                    SearchString: '',
                    From: Vue.moment().add(-30, 'days').hour('00').minutes('00').format('DD/MM/YYYY HH:mm'),
                    To: Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm'),
                    Status: '',
                    isActive: 1
                },
                statusesActive: [
                    {
                        id: 1,
                        value: 'Действующие'
                    },
                    {
                        id: 2,
                        value: 'Просроченные'
                    }
                ],
                statuses: [
                    {
                        id: 1,
                        value: 'Заявка принята'
                    },
                    {
                        id: 2,
                        value: 'Гость зарегистрирован'
                    },
                    {
                        id: 3,
                        value: 'Карта выдана'
                    },
                    {
                        id: 4,
                        value: 'Ошибка выдачи карты'
                    }
                    // {
                    //     id: 5,
                    //     value: 'Завершена'
                    // }
                ],
                dataTableToFilter: [],
                dataTable: [],
                model: {},
                sendVisible: false,
                sendModel: {
                    ID: 0,
                    DefaultMailBody: '',
                    QrCodeContent: ''
                },
                devices: [],
                fetchCardVisible: false,
                fetchCardModel: {
                    ID: '',
                    deviceId: ''
                },
                closeGuestVisible: false,
                closeGuestModel: {
                    ID: '',
                    date: Vue.moment().hour('23').minutes('59').format('YYYY-MM-DD 00:00:00'),
                },
                companies: []
            }
        },
        created () {
            this.getCompanies()
            this.getDevices()
            this.getData()
        },
        methods: {
            getDevices () {
                let request = {
                    Name: "GetItemsList",
                    ItemType: "Device"
                }

                this.$api.Main.getDevices(request).then(response => {
                    this.devices = response.Items.filter(row => {
                        if (row.Type === 1 && row.OnlineStatus.Value === 2 && row.Mode.Value === 2) {
                            return { ID: row.ID, Name: row.Name }
                        }
                    })
                })
            },
            handleSizeChange (val) {
                this.form.PageSize = val
                this.getData()
            },
            handleCurrentChange (val) {
                this.form.Page = val
                this.getData()
            },
            handleFilter () {
                this.getData()
            },
            getData () {
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemRows",
                    ItemType: "GuestTransaction"
                }, this.form)

                // request.Filter = {
                //     Type: "Simple",
                //     Field: "State",
                //     Operation: "Equal",
                //     Value: 2
                // }

                this.$api.Guest.getGuests(request).then(response => {
                    this.loading = false
                    this.dataTableToFilter = response
                    this.filterData()
                    this.total = response.Total
                }).catch (() => {
                    this.loading = false
                })
            },
            filterData () {
                this.dataTable = { ... this.dataTableToFilter }

                if (this.form.isActive === 1) {
                    this.dataTable.Rows = this.dataTable.Rows.filter(x =>
                        x.Cells.some(y => y.DataMember === 'EntryTimeEnd' && Vue.moment(y.Value).format() > Vue.moment().format())
                    )
                } else {
                    this.dataTable.Rows = this.dataTable.Rows.filter(x =>
                        x.Cells.some(y => y.DataMember === 'EntryTimeEnd' && Vue.moment(y.Value).format() <= Vue.moment().format())
                    )
                }

                if (this.form.Status) {
                    let status = this.statuses.find(x => x.id === this.form.Status).value

                    this.dataTable.Rows = this.dataTable.Rows.filter(x =>
                        x.Cells.some(y => y.DataMember === 'State' && y.Value === status)
                    )
                }
            },
            exportCSV () {

            },
            resetForm () {
                this.model = {
                    ID: 0,
                    ArendatorID: ((this.$loginType() === 2 || this.$loginType() === 4) && this.companies ? this.companies[0].ID : ''),
                    GuestName: '',
                    GuestPhone: '',
                    GuestMail: '',
                    GuestPlace: '',
                    CarPlate: '',
                    EntryTimeBegin: Vue.moment().hour('00').minutes('00').format('YYYY-MM-DD 00:00:00'),
                    EntryTimeEnd: Vue.moment().hour('23').minutes('59').format('YYYY-MM-DD 23:59:59'),
                    sendInvite: false
                }
            },
            closeGuest (id) {
                this.closeGuestVisible = true
                this.closeGuestModel.ID = id
            },
            close () {
                let request = {
                    Name: 'ExecuteFunction',
                    ItemType: 'GuestTransaction',
                    FunctionName: 'Close',
                    FunctionParameters: [this.closeGuestModel.ID, this.closeGuestModel.date]
                }

                this.$api.Guest.closeGuest(request).then(response => {
                    if (response.Result === 'Failed') {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error'
                        })
                    }
                    else {
                        this.$message({
                            message: 'Заявка закрыта',
                            type: 'success',
                            res: response
                        })
                        this.getData()
                        this.closeGuestVisible = false
                    }
                })
            },
            editGuest (row) {
                this.clearFormErrors('form')
                this.model = {
                    ID: row.find(x => x.DataMember === 'ID').Value,
                    ArendatorID: parseInt(row.find(x => x.DataMember === 'ArendatorID').Value),
                    GuestName: row.find(x => x.DataMember === 'GuestName').Value,
                    GuestPhone: row.find(x => x.DataMember === 'GuestPhone').Value,
                    GuestMail: row.find(x => x.DataMember === 'GuestMail').Value,
                    GuestPlace: row.find(x => x.DataMember === 'GuestPlace').Value,
                    CarPlate: row.find(x => x.DataMember === 'CarPlate').Value,
                    EntryTimeBegin: row.find(x => x.DataMember === 'EntryTimeBegin').Value,
                    EntryTimeEnd: row.find(x => x.DataMember === 'EntryTimeEnd').Value,
                    sendInvite: false
                }
                this.editMode = true
                this.addVisible = true
            },
            addGuest () {
                this.resetForm()
                setTimeout(() => this.clearFormErrors('form'), 1)
                this.editMode = false
                this.addVisible = true
            },
            save () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.clearFormErrors('form')

                        if (this.editMode) {
                            let request = {
                                Name: 'SetItemProperties',
                                ItemType: 'GuestTransaction',
                                ItemId: this.model.ID,
                                ItemProperties: Object.entries(this.model).map(row => {
                                    return {
                                        ItemPropertyName: row[0],
                                        ItemPropertyValue: row[1]
                                    }
                                })
                            }
                            this.$api.Guest.editGuest(request).then(response => {
                                if (response.Result === 'Failed') {
                                    this.$message({
                                        message: response.ErrorString,
                                        type: 'error'
                                    })
                                } else {
                                    this.$message({message: 'Заявка сохранена', type: 'success', res: response})
                                    this.addVisible = false
                                    this.getData()

                                    if (this.model.sendInvite) {
                                        this.sendMail(this.model.ID)
                                    }
                                }
                            }).catch ((response) => {
                                this.$message({ message: 'Ошибка сохранения заявки', type: 'error', res: response })
                            })
                        } else {
                            let request = {
                                Name: 'AddItem',
                                ItemType: 'GuestTransaction',
                                ItemProperties: Object.entries(this.model).map(row => {
                                    return {
                                        ItemPropertyName: row[0],
                                        ItemPropertyValue: row[1]
                                    }
                                })
                            }
                            this.$api.Guest.addGuest(request).then(response => {
                                if (response.Result === 'Failed') {
                                    this.$message({
                                        message: response.ErrorString,
                                        type: 'error'
                                    })
                                } else {
                                    this.$message({message: 'Заявка добавлена', type: 'success', res: response})
                                    this.addVisible = false
                                    this.getData()

                                    if (this.model.sendInvite) {
                                        this.sendMail(parseInt(response.ItemId))
                                    }
                                }
                            }).catch ((response) => {
                                this.$message({message: 'Ошибка добавления заявки', type: 'error', res: response})
                            })
                        }
                    }
                })
            },
            deleteItem (id) {
                this.$confirm('Вы уверены что хотите удалить заявку?', { confirmButtonText: 'OK', cancelButtonText: 'Отмена', type: 'warning' }).then(() => {
                    let request = {
                        Name: "RemoveItem",
                        ItemType: "GuestTransaction",
                        ItemId: id
                    }

                    this.$api.Guest.deleteGuest(request).then(response => {
                        if (response.Result === 'Failed') {
                            this.$message({
                                message: response.ErrorString,
                                type: 'error'
                            })
                        }
                        else {
                            this.$message({
                                message: 'Заявка удалена',
                                type: 'success',
                                res: response
                            })
                            this.getData()
                        }
                    })
                })
            },
            fetchCard (id) {
                console.log('fetch')
                this.fetchCardVisible = true
                this.fetchCardModel.ID = id
            },
            fetch () {
                let request = {
                    Name: 'ExecuteFunction',
                    ItemType: 'Device',
                    FunctionName: 'EjectCard',
                    FunctionParameters: [this.fetchCardModel.deviceId, this.fetchCardModel.ID]
                }

                this.$api.Guest.fetchCard(request).then(response => {
                    if (response.Result === 'Failed') {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error'
                        })
                    }
                    else {
                        this.$message({
                            message: 'Карта выдана',
                            type: 'success',
                            res: response
                        })
                        this.fetchCardVisible = false
                    }
                })
            },
            sendMail (id) {
                console.log('sendMail')
                this.loadingMail = true

                let request = {
                    Name: 'GetGuestInvitationText',
                    ItemType: 'GuestTransaction',
                    ItemId: id,
                }

                this.$api.Guest.getMail(request).then(response => {
                    this.loadingMail = false
                    this.sendModel = response
                    this.sendModel.ID = id
                    this.sendVisible = true
                }).catch (() => {
                    this.loadingMail = false
                })
            },
            send () {
                // this.sendModel.DefaultMailBody = this.$refs.toastuiEditor.invoke('getHtml')

                let request = {
                    Name: 'ExecuteFunction',
                    ItemType: 'GuestTransaction',
                    FunctionName: 'SendInvitation',
                    FunctionParameters: [this.sendModel.ID, this.sendModel.DefaultMailBody]
                }

                this.$api.Guest.send(request).then(response => {
                    if (response.Result === 'Failed') {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error'
                        })
                    }
                    else {
                        this.$message({
                            message: 'Приглашение отправлено',
                            type: 'success',
                            res: response
                        })
                        this.sendVisible = false
                    }
                })
            },
            print () {

            },
            goToReport () {
                this.$router.push({ name: 'guestsReport' })
            },
            tableRowClassName ({row}) {
                return row.ColorScheme
            },
            tableRowStyle ({row}) {
                if (row.BackgroundColor || row.ForegroundColor) {
                    return { backgroundColor: row.BackgroundColor, color: row.ForegroundColor }
                }
                else return ''
            },
            getCompanies() {
                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Company",
                    OperatorName: "Admin"
                }, this.form)

                this.$api.Main.getCompanies(request).then(response => {
                    this.companies = response.Items
                }).catch (() => {

                })
            },
            tomorrow () {
                this.model.EntryTimeBegin = Vue.moment().add(+1, 'days').format('YYYY-MM-DD 00:00:00')
                this.model.EntryTimeEnd = Vue.moment().add(+1, 'days').format('YYYY-MM-DD 23:59:59')
            },
            dropdownHandle () {
                console.log('fff')
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .guests {
        &__header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .right {
                justify-content: flex-end;
            }
        }
        .el-card__body {
            padding: 0;
        }
    }
</style>
